import {
  Backdrop, Button, Card, CardContent, CardHeader, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogTitle,
  Divider, Grid, Input, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography,
  InputAdornment, TextField, FormControl, CardActions
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Page from 'src/components/Page';
import axios from "src/utils/axios";
import { CreateWareHouseAddress, getUser, sc } from 'src/utils/Common';
import SearchIcon from '@material-ui/icons/Search';
import clsx from 'clsx';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));
const defaultUyari = { open: false, aciklama: '', tip: 'success' };

function MyPass() {
  const classes = useStyles();
  const [Loading, setLoading] = React.useState(false);
  const [dataPaslasma, setPaslasmaData] = React.useState([]);
  const [uyari, setUyari] = React.useState(defaultUyari);
  const [pagination, setPagination] = React.useState({ page: 0, rowsPerPage: 10 });
  const user = getUser();
  const [search, setSearch] = React.useState('');
  const [passEditParam, setPassEditParam] = React.useState('');
  const [oldData, setoldData] = React.useState([]);
  const [UstDurum, setUstDurum] = React.useState({
    checkedA: true,
    checkedB: true,
    checkedC: true,
    checkedD: true,
  });

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(defaultUyari);
  };
  const handleSearch = (Param) => {
    setSearch(Param);

    setPaslasmaData(oldData.filter(item => sc(item.PASLASMA_NO, Param) || sc(item.SERVIS, Param) || sc(item.TALEP_EDEN, Param)
      || sc(item.TELEFON, Param)
      || sc(item.TARIH, Param)
      || sc(item.DURUM, Param)
      || sc(item.MALZEME_STOK_NO, Param)
      || sc(item.GONDERI_TIP, Param)
      || sc(item.GONDERI_KODU, Param)
      || sc(item.FIS_NO, Param)
    ))
  }



  const GetOpenPassByService = () => {
    setLoading(true);
    axios.get("GetOpenPassByService/4/" + user.ServiceShopId)
      .then(response => {
        // console.log(response);
        setPaslasmaData(response.data);
        setoldData(response.data);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });
  }

  useEffect(() => {
    CreateWareHouseAddress(user.ServiceShopId);
    GetOpenPassByService();
  }, []);

  function PassProcess(ISLEM_TIPI, ID) {
    confirmAlert({
      message: 'Paslaşma talebi iptal edilecektir. Devam etmek istediğinzden eminmisiniz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => PassProcessKabul(ISLEM_TIPI, ID)
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });
  }
  function PassProcessKabul(ISLEM_TIPI, ID) {
    setLoading(true);
    const data = {
      ISLEM_TIPI: ISLEM_TIPI,
      ID: ID,
      USERID: user.UserId
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/SetPassProcess', data, config)
      .then(response => {
        if (response.data.ErrorCode === "0") {
          setUyari({ open: true, aciklama: 'İşlem başarılı', tip: 'success' });
        } else {
          setUyari({ open: true, aciklama: response.data.ErrorDescription, tip: 'error' });
        }
        GetOpenPassByService();
        setLoading(false);
      }).catch(error => {
        setUyari({ open: true, aciklama: 'Bir hata oluştu!..' + error.message, tip: 'error' });
        setLoading(false);
      });

  }




  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('');
  const [passEdit, setPassEdit] = React.useState(false);

  const GetPassEditPopUp = (event, ID) => {
    setPassEditParam(ID);
    setPassEdit(true);
  }


  const [Envalue, setEnvalue] = React.useState();

  const handleEnInputChange = (event) => {
    setEnvalue(event.target.value === '' ? '' : event.target.value);
  };

  const [Boyvalue, setBoyvalue] = React.useState();

  const handleBoyInputChange = (event) => {
    setBoyvalue(event.target.value === '' ? '' : event.target.value);
  };

  const [Yukseklikvalue, setYukseklikvalue] = React.useState();

  const handleYukseklikInputChange = (event) => {
    setYukseklikvalue(event.target.value === '' ? '' : event.target.value);
  };

  const [Desivalue, setDesivalue] = React.useState();

  const handleDesiInputChange = (event) => {
    setDesivalue(event.target.value === '' ? '' : event.target.value);
  };

  const [KargoTutarvalue, setKargoTutarvalue] = React.useState();

  const handleKargoTutarInputChange = (event) => {
    setKargoTutarvalue(event.target.value === '' ? '' : event.target.value);
  };

  function SetKargoBilgisi() {
    const data = {
      EN: Envalue,
      BOY: Boyvalue,
      YUKSEKLIK: Yukseklikvalue,
      DESI: Desivalue,
      KARGO_TUTAR: KargoTutarvalue,
      ID: passEditParam,
      USERID: user.UserId
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/SetPassKargoBilgisi', data, config)
      .then(response => {
        if (response.data.ErrorCode === "0") {
          setUyari({ open: true, aciklama: 'İşlem başarılı', tip: 'success' });
        } else {
          setUyari({ open: true, aciklama: response.data.ErrorDescription, tip: 'error' });
        }
        GetOpenPassByService();
        setLoading(false);
        setPassEdit(false);
      }).catch(error => {
        setUyari({ open: true, aciklama: 'Bir hata oluştu!..' + error.message, tip: 'error' });
        setLoading(false);
      });
  }

  const GetTruck = (event, ID) => {
    var LinkTruck = process.env.REACT_APP_TRUCK_URL + ID;
    event.persist();
    window.open(LinkTruck);
    event.persist();
  }

  const handleChangeUstDurum = (event) => {

    var A;
    var B;
    var C;
    var D;

    if (UstDurum.checkedA){
      A = "Açik Siparis";
    }else{
      A = "0";
    }
    if (UstDurum.checkedB){
      B = "Teslimi Bekleniyor";
    }else{
      B = "0";
    }
    if (UstDurum.checkedC){
      C = "Teslim Alindi";
    }else{
      C = "0";
    }
    if (UstDurum.checkedD){
      D = "Iptal Siparis";
    }else{
      D = "0";
    }


    if (event.target.name === "checkedA") {
      if (!event.target.checked) {
        A = "0";
      } else {
        A = "Açik Siparis";
      }
    }
    if (event.target.name === "checkedB") {
      if (!event.target.checked) {
        B = "0";
      } else {
        B = "Teslimi Bekleniyor";
      }
    }
    if (event.target.name === "checkedC") {
      if (!event.target.checked) {
        C = "0";
      } else {
        C = "Teslim Alindi";
      }
    }
    if (event.target.name === "checkedD") {
      if (!event.target.checked) {
        D = "0";
      } else {
        D = "Iptal Siparis";
      }
    }
  

    setPaslasmaData(oldData.filter(item => sc(item.UST_DURUM, A)
      || sc(item.UST_DURUM, B)
      || sc(item.UST_DURUM, C)
      || sc(item.UST_DURUM, D)
    ));

    setUstDurum({ ...UstDurum, [event.target.name]: event.target.checked });
  };

  return (
    <Page className={classes.root} title="oasis Yönetimi">
      <Container maxWidth="xl">
        <Card>
          <CardHeader title={' Paslaşma Taleplerim'}></CardHeader>
          <Backdrop className={classes.backdrop} open={Loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <Divider />
          <Snackbar open={uyari.open} autoHideDuration={6000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={uyariKapat}>
            <Alert onClose={uyariKapat} severity={uyari.tip}>
              {uyari.aciklama || ''}
            </Alert>
          </Snackbar>

          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12}>
                <FormGroup row>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={UstDurum.checkedA}
                        onChange={handleChangeUstDurum}
                        name="checkedA"
                      />
                    }
                    label="Açik Siparis"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={UstDurum.checkedB}
                        onChange={handleChangeUstDurum}
                        name="checkedB"
                      />
                    }
                    label="Teslimi Bekleniyor"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={UstDurum.checkedC}
                        onChange={handleChangeUstDurum}
                        name="checkedC"
                      />
                    }
                    label="Teslim Alindi"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={UstDurum.checkedD}
                        onChange={handleChangeUstDurum}
                        name="checkedD"
                      />
                    }
                    label="Iptal Siparis"
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Divider />
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormControl fullWidth className={classes.margin} style={{ paddingTop: '15px' }}>
                  <TextField
                    label="Arama Yapınız..."
                    value={search}
                    className={clsx(classes.margin, classes.textField)}
                    onChange={e => handleSearch(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <SearchIcon />
                        </InputAdornment>
                      )
                    }}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <TableContainer style={{ maxHeight: 600, minHeight: 500, }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    {/* <TableCell align="left">Güncelle</TableCell> */}
                    <TableCell align="left">İptal</TableCell>
                    <TableCell align="left">PaslaşmaNo</TableCell>
                    <TableCell align="left">FişNo</TableCell>
                    <TableCell align="left">Servis</TableCell>
                    <TableCell align="left">TicariÜnvan</TableCell>
                    <TableCell align="left">Telefon</TableCell>
                    <TableCell align="left">Tarih</TableCell>
                    <TableCell align="left">ÜstDurum</TableCell>
                    <TableCell align="left">Durum</TableCell>
                    <TableCell align="left">MalzemeKodu</TableCell>
                    <TableCell align="left">Malzeme</TableCell>
                    <TableCell align="left">Adet</TableCell>
                    <TableCell align="left">GönderiTip</TableCell>
                    <TableCell align="left">GönderiKodu</TableCell>
                    <TableCell align="left">KargoÖdeme</TableCell>
                    <TableCell align="left">KargoTakip</TableCell>
                    <TableCell align="left">Ödero</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataPaslasma.slice(pagination.page * pagination.rowsPerPage, (pagination.page + 1) * pagination.rowsPerPage).map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="left">
                        {
                          row.IPTAL === 0 ? '' : <DeleteForeverIcon
                            onClick={() => PassProcess(3, row.ID)}
                            color="error" />
                        }
                      </TableCell>
                      <TableCell align="left" >
                        {row.PASLASMA_NO}
                      </TableCell>
                      <TableCell align="left" >
                        {row.FIS_NO}
                      </TableCell>
                      <TableCell align="left" >
                        {row.SERVIS}
                      </TableCell>
                      <TableCell align="left" >
                        {row.TALEP_EDEN}
                      </TableCell>
                      <TableCell align="left" >
                        {row.TELEFON}
                      </TableCell>
                      <TableCell align="left" >
                        {row.TARIH}
                      </TableCell>
                      <TableCell align="left" >
                        {row.UST_DURUM}
                      </TableCell>
                      <TableCell align="left" >
                        {row.DURUM}
                      </TableCell>
                      <TableCell align="left" >
                        {row.MALZEME_STOK_NO}
                      </TableCell>
                      <TableCell align="left" >
                        {row.MALZEME_ACIKLAMA}
                      </TableCell>
                      <TableCell align="left">
                        {row.ADET}
                      </TableCell>
                      <TableCell align="left">
                        {row.GONDERI_TIP}
                      </TableCell>
                      <TableCell align="left">
                        {row.GONDERI_KODU}
                      </TableCell>
                      <TableCell align="left">
                        {row.KARGO_ODEME_DURUM}
                      </TableCell>
                      <TableCell align="left" >
                        {row.GONDERI_TIP === 'Aras Kargo' ?
                          <LocalShippingIcon
                            onClick={(event) => GetTruck(event, row.ID)}
                            color="primary" />
                          : ''}
                      </TableCell>
                      <TableCell align="left">
                        {row.orderId}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={dataPaslasma.length}
              rowsPerPage={pagination.rowsPerPage}
              page={pagination.page}
              onChangePage={(e, v) => setPagination({ ...pagination, page: v })}
              onChangeRowsPerPage={e => setPagination({ page: 0, rowsPerPage: e.target.value })}
            />
          </CardContent>
        </Card>
      </Container>
      <Dialog
        open={passEdit}
        onClose={() => setPassEdit(false)}
        keepMounted
        style={{ Width: 500, Height: 500, }}
      >
        <DialogTitle id="alert-dialog-title">
          Kargo Bilgileri
        </DialogTitle>

        <DialogContent>

          <div className={classes.root}>

            <Typography id="input-slider" gutterBottom>
              EN
            </Typography>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <Input
                  className={classes.input}
                  value={Envalue}
                  margin="dense"
                  onChange={handleEnInputChange}
                />
              </Grid>
            </Grid>

            <Typography id="input-slider" gutterBottom>
              BOY
            </Typography>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <Input
                  className={classes.input}
                  value={Boyvalue}
                  margin="dense"
                  onChange={handleBoyInputChange}
                />
              </Grid>
            </Grid>

            <Typography id="input-slider" gutterBottom>
              YÜKSEKLİK
            </Typography>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <Input
                  className={classes.input}
                  value={Yukseklikvalue}
                  margin="dense"
                  onChange={handleYukseklikInputChange}
                />
              </Grid>
            </Grid>


            <Typography id="input-slider" gutterBottom>
              DESİ
            </Typography>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <Input
                  className={classes.input}
                  value={Desivalue}
                  margin="dense"
                  onChange={handleDesiInputChange}
                />
              </Grid>
            </Grid>


            <Typography id="input-slider" gutterBottom>
              KARGO TUTAR
            </Typography>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <Input
                  className={classes.input}
                  value={KargoTutarvalue}
                  margin="dense"
                  onChange={handleKargoTutarInputChange}
                />
              </Grid>
            </Grid>


          </div>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => SetKargoBilgisi()}
            className={classes.button}
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            Güncelle
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}

export default MyPass;
